<div class="mx-auto max-w-md">
  <app-card>
    <form [formGroup]="loginForm" (ngSubmit)="loginUser()" class="space-y-5">
      @if (showAlert) {
        <app-alert [severity]="severity" [message]="message" />
      }

      <div>
        <h1 class="text-xl font-bold text-fg">Inloggen</h1>
        <p class="mt-1 text-sm text-fg-muted">
          Vul je gegevens in om verder te gaan
        </p>
      </div>

      <app-field label="E-mailadres" for="email" [control]="email">
        <input
          appInput
          [control]="email"
          formControlName="email"
          id="email"
          type="email"
          autocomplete="email"
          placeholder="jij@voorbeeld.be"
        />
      </app-field>

      <app-field label="Wachtwoord" for="password" [control]="password">
        <input
          appInput
          [control]="password"
          formControlName="password"
          id="password"
          type="password"
          autocomplete="current-password"
          placeholder="Je wachtwoord"
        />
      </app-field>

      <div class="flex justify-end">
        <a
          routerLink="/paswoord-vergeten"
          class="inline-flex min-h-11 items-center text-sm text-fg-muted hover:text-brand hover:underline"
        >
          Wachtwoord resetten
        </a>
      </div>

      <button
        appButton
        type="submit"
        class="w-full"
        [disabled]="loginForm.invalid || loginForm.pending || inSubmission"
      >
        Inloggen
      </button>

      <p class="text-sm text-fg-muted">
        Nog geen account?
        <a
          routerLink="/aanmelden"
          class="font-semibold text-fg hover:text-brand hover:underline"
        >
          Aanmelden
        </a>
      </p>
    </form>
  </app-card>
</div>
